import { ToolManager } from './ToolManager';

/**
 * The tool state of one viewer: the ToolManager its input surface dispatches
 * to. Created with the viewer's ViewManager, which routes the input of every
 * surface attached to it here, so every consumer that reads or drives the
 * armed tool reaches the one the user acts through.
 */
export class InteractionContext {
    public readonly toolManager: ToolManager;

    public constructor() {
        this.toolManager = new ToolManager();
    }

    /**
     * Tears down the armed tool and any gesture in progress. The context
     * stays usable: a tool armed afterwards starts from a clean state.
     */
    public dispose(): void {
        this.toolManager.dispose();
    }
}
